import React from 'react';
import { BoxIcon } from 'lucide-react';
import { CreativeDirectoryPage, CreativeArtist } from '../../components/creative/CreativeDirectoryPage';
const artists: CreativeArtist[] = [{
  id: '1',
  name: 'Mike Anderson',
  title: '3D Artist',
  specialties: ['Character Modeling', 'Environment Design', 'Animation'],
  rating: 4.8,
  reviewCount: 92,
  imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$400-1200'
}, {
  id: '2',
  name: 'Sarah Lee',
  title: '3D Modeling Specialist',
  specialties: ['Book Covers', 'Product Visualization', 'Architectural'],
  rating: 4.7,
  reviewCount: 78,
  imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$350-900'
}];
const ThreeDimensionalArtists = () => <CreativeDirectoryPage title="3D Artists" subtitle="Connect with talented 3D artists for book covers, character models, and promotional materials" icon={<BoxIcon className="h-8 w-8" data-id="element-8629" data-mp="268x8yvcawunf" />} profileBasePath="/creative/3d-artists" artists={artists} data-id="element-8628" data-mp="1xyetbbv6noq8" />;
export default ThreeDimensionalArtists;